import { render, staticRenderFns } from "./ModalSkill.vue?vue&type=template&id=59f1f2e0&"
import script from "./ModalSkill.vue?vue&type=script&lang=js&"
export * from "./ModalSkill.vue?vue&type=script&lang=js&"
import style0 from "./ModalSkill.vue?vue&type=style&index=0&id=59f1f2e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports